import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Box,
  Grid,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import { AddRolePermissionsResponse } from "../../../models/role.model";
import { DeleteRolePermission } from "../../../services/role.service";
import TabsEmptyStyle from "./TabsEmptyStyle";

interface Props {
  tableData: AddRolePermissionsResponse[];
  setUpdate: any;
  activeTab: number;
}
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  maxHeight: "70vh",
  //   minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const PermissionRoleTabsTable = ({
  tableData,
  setUpdate,
  activeTab,
}: Props) => {
  const columns = [
    {
      id: 1,
      title:
        activeTab === undefined || 0
          ? `گروه مجوز`
          : activeTab === 1
          ? `گروه منو`
          : activeTab === 2
          ? `گروه گزارش`
          : "",
    },
    {
      id: 2,
      title:
        activeTab === undefined || 0
          ? `نام مجوز`
          : activeTab === 1
          ? `نام منو`
          : activeTab === 2
          ? `نام گزارش`
          : "",
    },
    {
      id: 3,
      title: "زمان اعطا",
    },
  ];
  return (
    <>
      {tableData?.length !== 0 ? (
        <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
          <Table
            stickyHeader
            sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
            aria-label="customized table"
          >
            <TableHead>
              <TableRow>
                {columns.length > 0 &&
                  columns.map((column) => (
                    <StyledTableCell align="center">
                      {column.title}
                    </StyledTableCell>
                  ))}
                <StyledTableCell align="center">
                  <MoreHorizIcon />
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableBody
              sx={{
                outline: "1px solid #DAE0E4",
              }}
            >
              {tableData?.length !== 0 &&
                tableData
                  ?.map((data: any) => (
                    <TableRows
                      permissionGroupTitle={data.permissionGroupTitle}
                      permissionName={data.permissionName}
                      creationDatePersian={data.creationDatePersian}
                      rolePermissionId={data.id}
                      setUpdate={setUpdate}
                      activeTab={activeTab}
                    />
                  ))
                  .reverse()}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <TabsEmptyStyle
          completeText={
            activeTab === undefined || 0
              ? `مجوزی مربوط به "وب سرویس" برای این نقش اضافه نشد`
              : activeTab === 1
              ? `مجوزی مربوط به "منوها" برای این نقش اضافه نشد`
              : activeTab === 2
              ? `مجوزی مربوط به "گزارشات" برای این نقش اضافه نشد`
              : ""
          }
        />
      )}
    </>
  );
};

export default PermissionRoleTabsTable;

export const TableRows = ({
  permissionGroupTitle,
  permissionName,
  creationDatePersian,
  rolePermissionId,
  setUpdate,
  activeTab,
}: {
  permissionGroupTitle: string;
  permissionName: string;
  creationDatePersian: string;
  rolePermissionId: number;
  setUpdate: any;
  activeTab: number;
}) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { mutate: DeleteRolePermissionMutate } = useMutation(
    DeleteRolePermission,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          toast.success("با موفقیت حذف گردید.");
          setUpdate(uuid());
        }
      },
      onError: () => {},
    }
  );

  const handleDel = () => {
    DeleteRolePermissionMutate({
      rolePermissionId: rolePermissionId,
    });
  };
  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissionGroupTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {permissionName}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {creationDatePersian}
          </p>
        </StyledTableCell>

        <StyledTableCell align="right" sx={{ borderTop: "none !important" }}>
          <span style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            <DeleteOutlineIcon
              onClick={() => setOpenDeleteModal(true)}
              style={{
                color: "#1D4A87",
                cursor: "pointer",
                marginInline: "3px",
              }}
            />
          </span>
        </StyledTableCell>
      </StyledTableRow>
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginBottom={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              آیا از حذف{" "}
              {activeTab === undefined || 0
                ? `گروه مجوز`
                : activeTab === 1
                ? `گروه منو`
                : activeTab === 2
                ? `گروه گزارش`
                : ""}{" "}
              <span style={{ fontWeight: "bold", color: "#E6123D" }}>
                "{permissionName}"
              </span>{" "}
              اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  // onClick={handleDel}
                  onClick={handleDel}
                >
                  بله
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  خیر
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};
